const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '')

const resolveUserApiBaseUrl = () => {
  if (process.env.REACT_APP_USER_API_URL) {
    return trimTrailingSlash(process.env.REACT_APP_USER_API_URL)
  }

  if (process.env.REACT_APP_BACK_URL) {
    return `${trimTrailingSlash(process.env.REACT_APP_BACK_URL)}/api/v1/user`
  }

  if (process.env.REACT_APP_BACKEND_URL) {
    const backendUrl = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL)
    if (backendUrl.endsWith('/api') || backendUrl.endsWith('/api/v1/user')) {
      return backendUrl
    }
    return `${backendUrl}/api`
  }

  return 'http://localhost:3001/api'
}

const resolveBackendUrl = () =>
  trimTrailingSlash(
    process.env.REACT_APP_BACK_URL ||
      process.env.REACT_APP_BACKEND_URL ||
      'http://localhost:3001'
  )

const backendUrl = resolveBackendUrl()
const userApiBaseUrl = resolveUserApiBaseUrl()

// Configuration for development vs production modes
export const config = {
    // Environment detection
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
    appName: process.env.REACT_APP_NAME || 'crypto_userpage',
    token: process.env.REACT_APP_CURRENCY || "KRW",
    // Backend URLs
    backendUrl,
    wsUrl: process.env.REACT_APP_WS_URL || backendUrl,

    // API configuration
    api: {
      baseUrl: userApiBaseUrl,
      // WebSocket configuration
      wsUrl: process.env.REACT_APP_WS_URL || backendUrl,
    },

    // Feature flags
    features: {
      // Enable direct backend calls in development for easier debugging
      directBackendCalls: process.env.NODE_ENV === 'development',

      // Enable detailed logging in development
      detailedLogging: process.env.NODE_ENV === 'development',

      // Enable WebSocket debugging in development
      wsDebugging: process.env.NODE_ENV === 'development',
    }
  }

  // Helper function to get current mode info
  export const getModeInfo = () => {
    return {
      mode: config.isDevelopment ? 'Development' : 'Production',
      apiUrl: config.api.baseUrl,
      wsUrl: config.api.wsUrl,
      directBackend: config.features.directBackendCalls,
    }
  }

  // Helper function to log configuration (only in development)
  export const logConfig = () => {
    if (config.isDevelopment) {
      console.log('🔧 Configuration:', getModeInfo())
    }
  }

  // Export default config
  export default config
